/**
 * @jsxRuntime classic
 * @jsx jsx
 */

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import { N800 } from '@atlaskit/theme/colors';
var linkStyles = css({
  color: "var(--ds-text, ".concat(N800, ")"),
  cursor: 'pointer'
});

/**
 * __Progress tracker link__
 */
var Link = function Link(_ref) {
  var href = _ref.href,
    onClick = _ref.onClick,
    label = _ref.label,
    testId = _ref.testId;
  return jsx("a", {
    css: linkStyles,
    href: href,
    onClick: onClick,
    "data-testid": testId
  }, label);
};
export default Link;